<!--
 * @Description  : 成功页面 信息卡片
-->
<template minapp='mpx' xlang='wxml'>
  <view class="es-card">
    <view class='es-card__title'>
      <view class='es-card__title-left'>
        <view>{{fromStationName}}</view>
        <es-icon name="arrow-switch-right" color="#666666" size='20' />
        <view>{{toStationName}}</view>
      </view>
      <view wx:if="{{price}}" class="es-card__title-price">
        <view class="es-card__rich-text small">¥</view>
        <view class="es-card__rich-text large">{{ price}}</view>
      </view>
    </view>
    <view class="es-card__title" wx:for="{{cardInfos}}" wx:for-index="idx">
      <view class='es-card__item es-card__item-text'>{{item.title}} : {{item.value}}</view>
      <view wx:if="{{idx === (cardInfos.length-1)}}" class="es-card__item-detail">
        查看详情
        <es-icon color="#666666" size='12' name="angle-right"></es-icon>
      </view>
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { getFinalPrice } from '@/utils/money'
  import { getStorage } from '@/utils/storage'
  import { STORAGE_SELECT_TICKET } from '@/utils/train-storage'
  import { TicketStatus } from '@/common/enum'
  import store from '@/store'
  createComponent({
    props: {
      ticket: {
        type: Object,
        value: ()=>{}
      }
    },
    computed: {
      cardInfos() {
        return [
          {
            title: '发车时间',
            value: this.startTime
          },
          {
            title: '乘客信息',
            value: this.passengerInfo
          },
          {
            title: '座席信息',
            value: this.seatInfo
          },
        ].filter(({value}) => value)
      },
      price() {
        var curPrice = ''
        if (this.ticket?.personal_pay !== undefined) {
          //退票 改签
          curPrice = getFinalPrice(this.ticket?.personal_pay)
        }
        return curPrice
      },
      passengerInfo() {
        let _passengerInfo = ''
        //退票 改签
        if (this.ticket?.passenger_name !== undefined) {
          _passengerInfo = this.ticket?.passenger_name
        } 
        return _passengerInfo
      },
      startTime() {
        //不需要区分退票改签 改签时只有一比订单 (^ _ ^) 当左边没说就行 
        return this.ticket?.start_time
      },
      fromStationName() {
        return this.ticket?.from_station_name
      },
      toStationName() {
        return this.ticket?.to_station_name
      },
      seatInfo() {
        let info = ''
        //退票
        if (this.ticket?.seat_type !== undefined) {
          const {
            seat_type,
            coach_no,
            seat_name
          } = this.ticket || {}
          info = coach_no ? seat_type + ' ' + coach_no + '车' + seat_name : ''
        } else {
          info = this.ticket?.seat_info
        }
        return info
      }
    },
    methods: {}
  })
</script>

<style scoped lang="stylus" src="./style.styl"></style>

<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'es-icon': '@didi/es-mpx-ui/lib/icon'
    }
  }
</script>